__turbopack_context__.v({
  "control": "auOVtG_control" + " " + __turbopack_context__.i(248112)["resetFocusOutline"],
  "disabled": "auOVtG_disabled",
  "outlined": "auOVtG_outlined",
  "supportingText": "auOVtG_supportingText",
  "texts": "auOVtG_texts",
  "wrapper": "auOVtG_wrapper" + " " + __turbopack_context__.i(248112)["focusWithinOutline"],
});
